import { render, staticRenderFns } from "./cover-dialog.vue?vue&type=template&id=cf18eca4&scoped=true"
import script from "./cover-dialog.vue?vue&type=script&lang=js"
export * from "./cover-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf18eca4",
  null
  
)

export default component.exports